module.exports = __webpack_public_path__ + "img/bespoke.8b57c21c.jpg";